// extracted by mini-css-extract-plugin
export default {"wrapper":"Change_wrapper__nSeWa","inner":"Change_inner__XVy1-","header":"Change_header__5no+S","body":"Change_body__YKGk3"};